module.exports = __webpack_public_path__ + "static/AMCHP-logo-99dce3b0359d71a35be2c6f512a3dd6f.png";